<template>
    <div>
        <header class="hidden-sm hidden-xs">
            <!-- Header Start -->
            <div class="header-area header-transparent">  <!--style="background-color: rgba(0,15, 30, 0.2);"-->
                <div class="main-header ">
                    <div class="header-bottom  header-sticky" style="background:transparent">
                        <div class="container-fluid">
                            <div class="row align-items-center mt-2">
                                <!-- Logo -->
                                <div class="col-xl-3 col-lg-3 col-md-1" style="padding: 10px">
                                    <div class="logo">
                                        <!-- logo-1 -->
                                        <router-link to="/" class="big-logo">
                                            <img src="/imagens/logoseletobranco.png" alt="" style="width: 150px; height: auto;">
                                         </router-link>
                                    </div>
                                </div>
                                <div class="col-xl-9 col-lg-9 col-md-9" style="text-align:center">
                                    <!-- Main-menu -->
                                    <div class="main-menu d-none d-lg-block" >
                                        <nav style="background-color: rgba(0,15, 30, 0.45); border-radius:100px;border:1px solid #cccccc;padding: 5px;">
                                            <ul id="navigation">
                                                <li><router-link to="/">Home</router-link></li>
                                                <li><router-link to="/sobre">Sobre</router-link></li>
                                                <li>
                                                    <router-link to="/produtos/1/Produtos">Produtos</router-link>
                                                    <ul class="submenu" style="text-align: left;background-color:#efe7e7;"> <!-- Submenu -->
                                                        <li v-for="seg in SegmentosMenu" :key="seg.psgId">
                                                            <router-link :to="'/produtos/' + seg.psgId + '/' + seg.psgNomeSegmento.replaceAll(' ', '-').replaceAll('/', '').replaceAll(',', '')">
                                                                {{ seg.psgNomeSegmento }}
                                                            </router-link>
                                                        </li>
                                                    </ul>
                                                    </li>
                                                <li><router-link to="/Noticias">Noticias</router-link></li>
                                                <li>
                                                    <router-link to="/videos">Vídeos</router-link>
                                                    <!--ul class="submenu"> 
                                                        <li v-for="seg in SegmentoVideo" :key="seg.sgiId">
                                                            <router-link :to="'/videos/' + seg.sgiId + '/' + seg.sgiNomeSegmento.replaceAll(' ', '-').replaceAll('/', '').replaceAll(',', '')">
                                                                {{ seg.sgiNomeSegmento }}
                                                            </router-link>
                                                        </li>
                                                    </!--ul-->
                                                </li>
                                                <li><router-link to="/Eventos">Eventos</router-link></li>
                                                <li><router-link to="/faleconosco">Contato</router-link></li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Header End -->
        </header>

        <div class="container hidden-lg hidden-md" style="padding-bottom: 60px;">
            <v-navigation-drawer v-model="drawer">
                <!-- Conteúdo do menu lateral -->
                <router-link to="/" class="scrollto"
                    style="color: #000;letter-spacing: 2px;padding-right: 0.3em;font-size: 25px;padding-top: 15px;">
                    <img src="/imagens/logo-seleto-invertido.png" style="width:150px;padding: 15px;">
                </router-link>
                <v-list>
                    <v-list-item link to="/">
                        <v-list-item-title>Home</v-list-item-title>
                    </v-list-item>
                    <v-list-item link to="/sobre">
                        <v-list-item-title>Sobre</v-list-item-title>
                    </v-list-item>
                    <v-list-item link @click="drawer3 = !drawer3; drawer = !drawer;">
                        <v-list-item-title class="d-inline">Produtos</v-list-item-title>
                        <v-list-item-icon>
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-list-item-icon>
                    </v-list-item>
                    <v-list-item link to="/noticias">
                        <v-list-item-title>Notícias</v-list-item-title>
                    </v-list-item>
                    <v-list-item link to="/videos">
                        <v-list-item-title class="d-inline">Vídeos</v-list-item-title>
                    </v-list-item>
                    <v-list-item link to="/Eventos">
                        <v-list-item-title class="d-inline">Eventos</v-list-item-title>
                    </v-list-item>
                    <v-list-item link to="/faleconosco">
                        <v-list-item-title>Contato</v-list-item-title>
                    </v-list-item>
                    <v-list-item link @click="drawer2 = !drawer2; drawer = !drawer;">
                        <v-list-item-title class="d-inline">Informações Gerais</v-list-item-title>
                        <v-list-item-icon>
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-list-item-icon>
                    </v-list-item>
                </v-list>
                <v-row class="justify-content-center" style="padding-top:30px;">
                    <div class="d-flex justify-content-center" v-if="redes != ''">
                        <a v-if="redes[0].itiNome != '' && redes[0].itiNome != null" :href="redes[0].itiNome"
                            target="_blank" title="Facebook" style="color:#000000;font-size:13px;padding-right:15px;"><i
                                class="icon-facebook-f"></i></a>
                        <a v-if="redes[0].itiReferencia != '' && redes[0].itiReferencia != null"
                            :href="redes[0].itiReferencia" target="_blank" title="Instagram"
                            style="color:#000000;font-size:13px;padding-right:15px;"><i class="icon-instagram"></i></a>
                        <a v-if="redes[0].itiCampoExtra1 != '' && redes[0].itiCampoExtra1 != null"
                            :href="redes[0].itiCampoExtra1" target="_blank" title="Youtube"
                            style="color:#000000;font-size:13px;padding-right:15px;"><i class="icon-youtube"></i></a>
                        <a v-if="redes[0].itiCampoExtra2 != '' && redes[0].itiCampoExtra2 != null"
                            :href="redes[0].itiCampoExtra2" target="_blank" title="Linkedin" style="color:#000000;"><i
                                class="icon-linkedin"></i></a>
                    </div><!-- End .social-icons -->

                </v-row>
            </v-navigation-drawer>


            <v-navigation-drawer v-model="drawer2">
                <!-- Conteúdo do menu lateral -->
                <router-link to="/" class="scrollto"
                    style="color: #000;letter-spacing: 2px;padding-right: 0.3em;font-size: 25px;padding-top: 15px;">
                    <img src="/imagens/logo-seleto-invertido.png" style="width:150px;padding: 15px;">
                </router-link>
                <v-list>
                    <v-list-item link @click="drawer2 = !drawer2; drawer = !drawer;">
                        <v-list-item-icon>
                            <v-icon class="d-inline">mdi-chevron-left</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title class="d-inline">Voltar</v-list-item-title>
                    </v-list-item>
                    <div v-for="itens in informacoes" :key="itens.itiId">
                        <v-list-item link
                            :to="'/informacoes/' + itens.itiId + '/' + itens.itiNome.replaceAll(' ', '-').replaceAll('/', '').replaceAll(',', '')">
                            <v-list-item-title> {{ itens.itiNome }}</v-list-item-title>
                        </v-list-item>
                    </div>
                </v-list>
            </v-navigation-drawer>

            <v-navigation-drawer v-model="drawer3" style="width: 330px">
                <!-- Conteúdo do menu lateral -->
                <router-link to="/" class="scrollto"
                    style="color: #000;letter-spacing: 2px;padding-right: 0.3em;font-size: 25px;padding-top: 15px;">
                    <img src="/imagens/logo-seleto-invertido.png" style="width:150px;padding: 15px;">
                </router-link>
                <v-list>
                    <v-list-item link @click="drawer3 = !drawer3; drawer = !drawer;">
                        <v-list-item-icon>
                            <v-icon class="d-inline">mdi-chevron-left</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title class="d-inline">Voltar</v-list-item-title>
                    </v-list-item>
                    <div v-for="seg in SegmentosMenu" :key="seg.psgId" class="d-inline">
                        <v-list-item link
                            :to="'/produtos/' + seg.psgId + '/' + seg.psgNomeSegmento.replaceAll(' ', '-').replaceAll('/', '').replaceAll(',', '')">
                            <!--i class="fa fa-cog" style="color:#000000;"></!--i-->
                            <v-list-item-title
                                style="font-weight: 500; font-size: 14px;padding-left: 8px;color:#333333;display: inline-flex;">
                                {{ seg.psgNomeSegmento }}</v-list-item-title>
                        </v-list-item>
                    </div>
                </v-list>
            </v-navigation-drawer>

            <v-app-bar app style="background-color: #000066" v-if="redes!=''">
    <v-app-bar-nav-icon @click.stop="drawer = !drawer" style="font-size: 20px; color: #ffffff;"></v-app-bar-nav-icon>
    <v-row align="center" class="logo-cart-container" style="flex-grow: 1;">
        <!-- Logo -->
        <v-col class="logo-col">
            <img src="/imagens/logoseletobranco.png" class="logo-img" style="width:80px;">
        </v-col>

        <!-- Contact Submenu Icon -->
        <v-col>
            <v-menu v-model="menuOpen" bottom left offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" color="white" @click="menuOpen = !menuOpen" style="font-size: 20px; cursor: pointer;">
                        mdi-account-box
                    </v-icon>
                </template>
                <v-list>
                    <v-list-item>
                        <v-list-item-title>
                            <i class="fa fa-phone" style="font-size: 17px;padding-right: 5px;color:#0a98f8"></i><span style="color:#000000">{{ dados[0].itiNome }}</span><br>
                            <a :href="dados[0].itiCampoExtra1" target="_blank" title="Whatsapp"><i class="fab fa-whatsapp" style="font-size: 20px;padding-right: 5px;color:rgb(10, 152, 248)"></i><span style="color:#000000">{{ dados[0].itiReferencia }}</span></a>
                            <p style="color:#000000;padding-top: 30px" class="info1" v-html="dados[0].itiResumo2"></p>
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-col>

        <!-- Phone Icon (Click to Call) -->
        <v-col>
            <a :href="'tel:' + dados[0].itiNome" style="color: inherit;">
                <v-icon color="white" style="font-size: 15px;">
                    mdi-phone
                </v-icon>
            </a>
        </v-col>

        <!-- Social Media Icons -->
        <v-col v-if="redes[0].itiReferencia">
            <a :href="redes[0].itiReferencia" target="_blank" style="color: inherit;">
                <v-icon color="white" style="font-size: 15px;">
                    mdi-instagram
                </v-icon>
            </a>
        </v-col>
        <v-col v-if="redes[0].itiNome">
            <a :href="redes[0].itiNome" target="_blank" style="color: inherit;">
                <v-icon color="white" style="font-size: 15px;">
                    mdi-facebook
                </v-icon>
            </a>
        </v-col>
        <v-col v-if="redes[0].itiCampoExtra2">
            <a :href="redes[0].itiCampoExtra2" target="_blank" style="color: inherit;">
                <v-icon color="white" style="font-size: 15px;">
                    mdi-linkedin
                </v-icon>
            </a>
        </v-col>
        <v-col v-if="redes[0].itiCampoExtra1">
            <a :href="redes[0].itiCampoExtra1" target="_blank" style="color: inherit;">
                <v-icon color="white" style="font-size: 15px;">
                    mdi-youtube
                </v-icon>
            </a>
        </v-col>
    </v-row>
</v-app-bar>


        </div>

    </div>
</template>

<script>
import axios from 'axios';
import Cookies from 'js-cookie';
import { mapState } from 'vuex';

export default {
    name: 'PageHeader',
    components: {

    },
    data: () => ({
        topo: [],
        redes: [],
        dados:[],
        menuOpen: false,
        pesquisaChave: '',
        informacoes: [],
        drawer: false,
        drawer2: false,
        drawer3: false,
        drawer4: false,
        drawer5: false,
        showSearch: false,
        Segmentos: [],
        SegmentosMenu: [],
        SegmentosInst: [],
        SegmentosMenuInst: [],
        SegmentoVideo:[],
        SegmentoCatalogo:[],
    }),
    methods: {
        Pesquisa() {
            if (this.pesquisaChave == "") {
                this.$mensagemAviso("Digite uma palavra chave para pesquisa.")
            }
            else {
                const novaURL = `/CestasporCategoriaPesquisa/${this.pesquisaChave}`;
                window.history.pushState({}, '', novaURL);
            }
        },
    },
    async created() {
        axios.get('/Process/InsInstitucional/institucional/10/rodape')
      .then(response => {
        this.dados = response.data;
      })
      .catch(error => {
        console.error(error);
      });

        axios.get('/Process/InsInstitucional/institucional/20/redessociais')
            .then(response => {
                this.redes = response.data;
            })
            .catch(error => {
                console.error(error);
            });

        axios.get('/Process/InsInstitucional/institucional/18/informacoes')
            .then(response => {
                this.informacoes = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
            })
            .catch(error => {
                console.error(error);
            });

        await axios.get('/Process/ProSegmentos/GetAll')
            .then(response => {
                this.Segmentos = response.data;
                this.SegmentosMenu = this.Segmentos.filter(x => x.psgIdPai == 0 && x.psgVisivel).sort((a, b) => {
                    const nomeA = a.psgNomeSegmento || "";
                    const nomeB = b.psgNomeSegmento || "";
                    return nomeA.localeCompare(nomeB);
                });
            })
            .catch(error => {
                console.error(error);
            });

            await axios.get('/Process/InsSegmentos/GetAll')
            .then(response => {
                this.SegmentosInst = response.data;
                this.SegmentosMenuInst = this.SegmentosInst.filter(x => x.sgiIdPai == 0 && x.sgiVisivel).sort((a, b) => {
                    const nomeA = a.sgiNomeSegmento || "";
                    const nomeB = b.sgiNomeSegmento || "";
                    return nomeA.localeCompare(nomeB);
                });

                this.SegmentoVideo = this.SegmentosMenuInst.filter(x=> x.ctiId == 35).sort((a, b) => a.sgiOrdem - b.sgiOrdem);
                this.SegmentoCatalogo = this.SegmentosMenuInst.filter(x=> x.ctiId == 31).sort((a, b) => a.sgiOrdem - b.sgiOrdem);

            })
            .catch(error => {
                console.error(error);
            });
    },
}
</script>

<style>
@media (max-width:768px) {
    .v-row {
    display: flex;
    flex-wrap: wrap;
    flex: 0 1 auto !important;
    margin: 0 !important;
}

.info1 p {
    color: #000000;
}

    .logo-col {
        flex: 1;
        /* Ajuste o valor para controlar o tamanho do logo */
    }

    .icon-col {
        flex: 1;
        /* Ajuste o valor para controlar o tamanho dos ícones e o espaço entre eles */
    }

    .search-container {
        position: absolute;
        background-color: white;
        /* Cor de fundo do campo de pesquisa */
        z-index: 1;
        /* Para sobrepor o conteúdo abaixo */
        width: 100%;
        /* Para ocupar a largura da barra de aplicativos */
        top: 60px;
        /* Ajuste conforme necessário para a posição vertical desejada */
        padding: 10px;
        /* Espaçamento interno do campo de pesquisa */
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        /* Sombra, opcional */
        margin-left: -15px !important;
    }

    .search-input {
        width: 100%;
        padding: 10px;
    }

    .cart-count {
    position: absolute;
    top: -3px;
    right: -3px;
    background-color: #B91F1C;;
    color: white;
    border-radius: 50%;
    padding-left: 6px;
    padding-right: 6px;
    padding-top: 3px;
    padding-bottom: 2px;
    font-size: 9px;
}

@media (min-width:1200px) {
    a .btn .cart-count {
    position: absolute;
    top: -15px;
    right: 9px;
    background-color: #B91F1C;;
    color: white;
    border-radius: 50%;
    padding-left: 6px;
    padding-right: 6px;
    padding-top: 3px;
    padding-bottom: 2px;
    font-size: 9px;
}
}

}
</style>
